var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row form-page-detail-body-container container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      !_vm.load_first
        ? _c(
            "div",
            {
              staticClass: "d-flex align-items-center justify-content-center",
              staticStyle: { height: "400px", width: "100%" }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTable
        ? _c(
            "div",
            { staticClass: "table-column" },
            [
              _c(
                "v-server-table",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.load_first,
                      expression: "load_first"
                    }
                  ],
                  ref: "recordTableComponent",
                  staticClass: "jTable",
                  attrs: { columns: _vm.columns, options: _vm.table_options },
                  on: {
                    loading: _vm.loading,
                    loaded: _vm.loaded,
                    sorted: _vm.sortingColumn
                  },
                  scopedSlots: _vm._u([
                    _vm._l(_vm.datasetColumn, function(i, index) {
                      return {
                        key: i.name,
                        fn: function(props) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row[i.name]) +
                                "\n        "
                            )
                          ])
                        }
                      }
                    }),
                    {
                      key: "delete_and_update",
                      fn: function(props) {
                        return _c("div", {}, [
                          _c("img", {
                            staticClass: "cursor-pointer m__r--5",
                            attrs: {
                              src: require("@/assets/icon/query/edit.svg"),
                              width: "13"
                            },
                            on: {
                              click: function($event) {
                                _vm.openDetail(props.row)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "cursor-pointer",
                            attrs: {
                              src: require("@/assets/icon/query/delete.svg"),
                              width: "13"
                            },
                            on: {
                              click: function($event) {
                                _vm.deleteItem(props.row)
                              }
                            }
                          })
                        ])
                      }
                    }
                  ])
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "custom-search",
                      attrs: { slot: "beforeFilter" },
                      slot: "beforeFilter"
                    },
                    [
                      _c(
                        "b-form",
                        { attrs: { inline: "" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "btn grey btn-import-form m__r--5",
                              on: { click: _vm.openModalData }
                            },
                            [
                              _c("i", { staticClass: "fa fa-plus fa-lg" }),
                              _vm._v(" Add\n          ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "btn grey btn-import-form m__r--5",
                              attrs: { id: "filterServerPopover" }
                            },
                            [
                              _c("i", { staticClass: "fa fa-filter fa-lg" }),
                              _vm._v(" Filter\n          ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showTable
        ? _c(
            "b-popover",
            {
              ref: "filterServerPopoverRef",
              attrs: {
                show: _vm.popoverFilterServerShow,
                container: "form-search-popover",
                target: "filterServerPopover",
                placement: "top"
              },
              on: {
                "update:show": function($event) {
                  _vm.popoverFilterServerShow = $event
                }
              }
            },
            [
              _c(
                "b-form",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.hideFilter,
                      expression: "hideFilter"
                    }
                  ],
                  attrs: { inline: "" },
                  on: {
                    keypress: function($event) {
                      if (!("button" in $event) && $event.keyCode !== 13) {
                        return null
                      }
                      $event.preventDefault()
                      _vm.$refs.recordTableComponent.setFilter(_vm.filter_data)
                      _vm.popoverFilterServerShow = false
                    }
                  }
                },
                [
                  _c("j-single-select", {
                    staticClass: "m__r--5",
                    staticStyle: { width: "200px" },
                    attrs: {
                      options: _vm.options_search,
                      "error-required": false,
                      placeholder: "Filter By",
                      label: "name"
                    },
                    model: {
                      value: _vm.select_type,
                      callback: function($$v) {
                        _vm.select_type = $$v
                      },
                      expression: "select_type"
                    }
                  }),
                  _vm._v(" "),
                  _c("j-single-select", {
                    staticClass: "m__r--5",
                    staticStyle: { width: "100px" },
                    attrs: {
                      options: _vm.options_filter,
                      "error-required": false,
                      clearable: false,
                      placeholder: "Select",
                      "value-format": "object",
                      label: "name"
                    },
                    model: {
                      value: _vm.select_option,
                      callback: function($$v) {
                        _vm.select_option = $$v
                      },
                      expression: "select_option"
                    }
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticStyle: { width: "250px !important" },
                    attrs: { placeholder: "Search" },
                    model: {
                      value: _vm.filter_data,
                      callback: function($$v) {
                        _vm.filter_data = $$v
                      },
                      expression: "filter_data"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appAddRecordModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("CREATE RECORD")
          ]),
          _vm._v(" "),
          _vm.showRecord
            ? _c("j-form-base", {
                ref: "jFormCreate",
                attrs: {
                  "data-fields": _vm.dataFields,
                  "is-detail": _vm.isDetail
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "12" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: { click: _vm.closeCreateData }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createRecordData }
                      },
                      [_vm._v("\n            Submit\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appEditRecordModal",
          staticClass: "mod-form modal-add-record-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("EDIT RECORD")
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "7" } }, [
                _c("label", [_vm._v(" JSON ")])
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "p__r--1", attrs: { md: "3" } }, [
                _c("small", { staticClass: "pull-right" }, [
                  _vm._v("Dark Mode")
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "p__l--1", attrs: { md: "2" } },
                [
                  _c("j-toggle", {
                    model: {
                      value: _vm.darkMode,
                      callback: function($$v) {
                        _vm.darkMode = $$v
                      },
                      expression: "darkMode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("prism-editor", {
            staticClass: "my-editor",
            class: { "dark-mode": _vm.darkMode },
            attrs: { highlight: _vm.highlighter, "line-numbers": true },
            model: {
              value: _vm.jsonData,
              callback: function($$v) {
                _vm.jsonData = $$v
              },
              expression: "jsonData"
            }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn red",
                      on: { click: _vm.deleteRecordData }
                    },
                    [_vm._v("\n          Delete\n        ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { md: "8" } }, [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray m__r--5",
                        on: {
                          click: function($event) {
                            _vm.$refs.appEditRecordModal.hide()
                          }
                        }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.updateRecordData }
                      },
                      [_vm._v("\n            Update\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "appImportRecordModal",
          staticClass: "mod-form modal-add-form-data",
          attrs: {
            centered: "",
            "no-close-on-esc": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "label-create-form-data" }, [
            _vm._v("IMPORT")
          ]),
          _vm._v(" "),
          _vm.dropboxImportShow
            ? _c("div", { staticClass: "dropbox-oos" }, [
                _c("input", {
                  staticClass: "input-file",
                  attrs: { type: "file", multiple: "" },
                  on: {
                    change: function($event) {
                      _vm.handleFileUpload($event.target.files)
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("@/assets/form-data/file-dropbox.png") }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "label-dropbox" }, [
                  _vm._v("Drop your file here, or "),
                  _c("span", [_vm._v("browse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "label-support-dropbox" }, [
                  _vm._v("Support : ZIP")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "float-to-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn gray",
                        on: { click: _vm.closeImportForm }
                      },
                      [_vm._v("\n            Close\n          ")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis" }, [
      _c("div"),
      _c("div"),
      _c("div"),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-787f7feb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787f7feb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/jDatasetData.vue
// module id = null
// module chunks = 